// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1d511","errors":"Errors_errors__JPw3X"};